import { Component, Input, OnInit } from "@angular/core";
import { BaseGroupType } from "src/AngularJS/Models/group-type.model";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { ModuleManager } from "src/shared/models/module-manager";
import { ExpandedSummaryService } from "../../modules/expanded-summary/expanded-summary.service";
import { ModuleSettingsView } from "src/shared/models/module-manager/module-manager-settings.models";
import { ExpandedSummaryGroups } from "../../modules/expanded-summary/expanded-summary.model";

@Component({
    selector: "cv-expanded-summary-settings",
    templateUrl: "./expanded-summary-settings.component.html",
    styleUrls: ["./expanded-summary-settings.component.scss"],
})
export class ExpandedSummarySettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;

    context: string;

    initialized: boolean = false;

    selectedPrimaryView: number = BaseGroupType.Employee;
    selectedEmpGroup: number = 0;
    selectedRecGroup: number = 0;

    empGroups: string[];
    recGroups: string[];

    // CXOne Dropdown Options
    primaryViewOptions: { id: number; name: string }[];
    empViewOptions: { id: number; name: string }[] = new Array<{ id: number; name: string }>();
    recViewOptions: { id: number; name: string }[] = new Array<{ id: number; name: string }>();

    private localizationStrings: Map<string, string> = new Map<
        string,
        string
    >();
    private empGroupLocalizedName: string;
    private recGroupLocalizedName: string;
    private expandedSummaryGroups: ExpandedSummaryGroups;

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private expandedSummaryService: ExpandedSummaryService
    ) {}

    get ModuleSettingsView() {
        return ModuleSettingsView;
    }

    ngOnInit() {
        this.setupSettings();

        this.moduleManager.addSetting({
            name: "PrimaryView",
            required: true,
            getValue: () => this.selectedPrimaryView,
            onSettingLoaded: (value) => {
                this.selectedPrimaryView = value ?? 0;
                this.onPrimaryViewChange();
            },
        });

        this.moduleManager.addSetting({
            name: "EmpGroup",
            required: true,
            getValue: () => this.selectedEmpGroup,
            onSettingLoaded: (value) => (this.selectedEmpGroup = value ?? 0),
        });

        this.moduleManager.addSetting({
            name: "RecGroup",
            required: true,
            getValue: () => this.selectedRecGroup,
            onSettingLoaded: (value) => (this.selectedRecGroup = value ?? 1),
        });

        this.moduleManager.customSettingsAdded = true;
    }

    private async setupSettings() {
        try {
            const [localizations, settings] = await Promise.all([
                this.cvLocalizationService.GetSection("Expanded_Summary"),
                this.expandedSummaryService.getSettings(
                    this.moduleManager.getModuleKey()
                ),
            ]);
            this.localizationStrings = localizations;
            this.expandedSummaryGroups = settings;
        } catch (error){
            console.error("Failed to load settings for Expanded Summary");
            throw error;
        } finally {
            this.empGroupLocalizedName =
                this.localizationStrings["Employee_Group"] ?? "Employee Group";
            this.recGroupLocalizedName =
                this.localizationStrings["Contact_Group"] ?? "Contact Group";
            this.empGroups = this.expandedSummaryGroups.EmpGroups;
            this.recGroups = this.expandedSummaryGroups.RecGroups;

            if (this.moduleManager.settingsView === ModuleSettingsView.CXOneModal) 
                this.prepareCxOneSettings();
            this.onPrimaryViewChange();
            this.initialized = true;
        }
    }

    private prepareCxOneSettings() { 
        this.primaryViewOptions = [
            { id: BaseGroupType.Employee, name: this.empGroupLocalizedName },
            { id: BaseGroupType.Recording, name: this.recGroupLocalizedName },
        ];
        for (let group of this.empGroups) {
            if (this.empGroups.indexOf(group) === 2) continue;
            this.empViewOptions.push({ id: this.empGroups.indexOf(group), name: group });
        }
        for (let group of this.recGroups) {
            if (this.recGroups.indexOf(group) === 0 || this.recGroups.indexOf(group) === 3) continue;
            this.recViewOptions.push({ id: this.recGroups.indexOf(group), name: group });
        }
    }

    public onPrimaryViewChange() {
        if (this.selectedPrimaryView == BaseGroupType.Employee)
            this.context = `${this.empGroupLocalizedName}, ${this.recGroupLocalizedName}`;
        else
            this.context = `${this.recGroupLocalizedName}, ${this.empGroupLocalizedName}`;
    }
}
